/**
 * z-index tokens.
 *
 * Aligned with MUI's default stacking context so custom layers compose
 * predictably with MUI overlays (Drawer, Modal, Snackbar, Tooltip).
 */

export const zIndex = {
  hide: -1,
  base: 0,
  docked: 10,
  sticky: 1100,
  appBar: 1100,
  banner: 1150,
  overlay: 1200,
  drawer: 1200,
  modal: 1300,
  popover: 1400,
  snackbar: 1400,
  tooltip: 1500,
} as const;

export type ZIndexToken = keyof typeof zIndex;
